export const SET_MENU_OPTION = "SET_MENU_OPTION";
export const DIALOG_OPEN = "DIALOG_OPEN";
export const SET_MENU_DRAWER = "SET_MENU_DRAWER";

export const ROUTER_PAYLOAD_UPDATER = "ROUTER_PAYLOAD_UPDATER";

export const SET_IS_MOBILE="SET_IS_MOBILE"
export const SET_SIGNUP_POPUP = "SET_SIGNUP_POPUP"